import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import autoBind from 'react-autobind';
import ActionButtons from '../../home/ActionButtons';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';

const propTypes = {
  dispatch: PropTypes.func,
  logs: PropTypes.any,
};

class ShowCampaigns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      log: {
        emailHtml: '',
        imageData: {},
        durationBreakdown: {},
      },
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillReceiveProps() {
  }
  renderRowsTable() {
    const options = {
      weekday: 'short', year: 'numeric', month: 'short',
      day: 'numeric', hour: '2-digit', minute: '2-digit',
    };
    return this.props.logs.map((log, i) =>
      <TableRow key={i}>
        <TableRowColumn
          style={{ textAlign: 'center' }}
          key={i}
        >
          {new Date(log.insertDate).toLocaleTimeString('en-us', options)}
        </TableRowColumn>
        <TableRowColumn style={{ textAlign: 'center' }} key={i}>{log.source}</TableRowColumn>
        <TableRowColumn style={{ textAlign: 'center' }} key={i}>{log.email}</TableRowColumn>
        <TableRowColumn style={{ textAlign: 'center' }} key={i}>{log.durationBreakdown.process_time}</TableRowColumn>
        <TableRowColumn key={i}>
          <ActionButtons
            onView={`/logging/campaigns/${log.id}`}
          />
        </TableRowColumn>
      </TableRow>
    );
  }
  render() {
    const tableStyles = {
      stripedRows: true,
      displaySelectAll: false,
      adjustForCheckbox: false,
      selectable: false,
      displayRowCheckbox: false,
    };
    return (
      <div>
        <Table selectable={false}>
          <TableHeader
            displaySelectAll={tableStyles.displaySelectAll}
            adjustForCheckbox={tableStyles.adjustForCheckbox}
          >
            <TableRow
              selectable={tableStyles.selectable}
            >
              <TableHeaderColumn style={{ textAlign: 'center' }}>Date</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Source</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Email</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Conversion Time</TableHeaderColumn>
              <TableHeaderColumn style={{ textAlign: 'center' }}>Actions</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody
            stripedRows={tableStyles.stripedRows}
            displayRowCheckbox={tableStyles.displayRowCheckbox}
          >
            {this.renderRowsTable()}
          </TableBody>
        </Table>
      </div>
    );
  }
}

ShowCampaigns.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

ShowCampaigns.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    logs: state.logs.results,
  };
}

export default connect(mapStateToProps)(ShowCampaigns);



// WEBPACK FOOTER //
// ./src/components/logging/campaigns/ShowCampaigns.js